import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import OrganizationsTable from "../components/OrganizationsTable";
import { ToastContainer } from 'react-toastify';

const OrganizationsInactivePage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Pasif" />
      <OrganizationsTable status="inactive" title="Pasif Organizasyonlar" />
    </MasterLayout>
  );
};

export default OrganizationsInactivePage;

